import { Directive, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { Router } from "@angular/router";
import { Message } from "@bbwt/classes";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { UserService } from "@main/users";
import { MessageService } from "primeng/api";
import { filter, Subject, takeUntil, tap } from "rxjs";

@Directive({
    selector: "[patient-watch],patient-watch"
})
export class PatientSelectWatchDirective implements OnDestroy {
    private destroyed$ = new Subject<void>();

    @Input() patientRequired: boolean = true;
    
    @Output()
    readonly patientIdChanged = new EventEmitter<string>();

    constructor(
        broadcastService: BroadcastService,
        userService: UserService,
        private patientService: PatientService,
        private router: Router,
        private messageService: MessageService
    ) {
        broadcastService
            .on(PatientService.CurrentPatientChangedEventName)
            .pipe(
                takeUntil(this.destroyed$),
                filter(_ => userService.isLogged),
                tap(_ => this.patientChanged())
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    private patientChanged() {
        if (this.patientService.currentPatientId) {
            this.patientIdChanged.emit(this.patientService.currentPatientId);
        } else {
            this.messageService.add(Message.Warning("No patient is selected", "Patient"));
            if(this.patientRequired) {
                this.router.navigate(["/"]);
            } else {
                this.patientIdChanged.emit(this.patientService.currentPatientId);
            }
        }
    }
}
